
import shortid from 'shortid';

function CustomAjaxError({ config, message, name, response }) {
    this.name = name;
    this.config = config;
    this.message = message || '';
    this.response = response;
    this.uid = shortid.generate();
    const error = new Error(this.message);
    error.name = this.name;
    this.stack = error.stack;
}

CustomAjaxError.prototype = Object.create(Error.prototype);

export default CustomAjaxError;



// WEBPACK FOOTER //
// ./src/errors/CustomAjaxError.js